import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from "vue"
import { usePlantStore } from "@/store/plant"
import PlantForm from "@/components/plant/PlantForm.vue"
import { useConfirm } from "primevue/useconfirm"
import useNotification from "@/logics/useNotification"
import ImageViewList from "@/components/plant/ImageViewList.vue"
import { useRouter } from "vue-router"


import { ref } from "vue"

const __default__ = {
  name: "PlantDetail"
}
const edit = ref(false)

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  id: {
    type: String,
    required: true
  }
},
  setup(__props, { expose }) {
  expose();

const props = __props



const tabIndex = ref(0)

const isLoading = ref(false)
const confirm = useConfirm()
const plantStore = usePlantStore()
const plant = computed(() => plantStore.plant)
const router = useRouter()
const notification = useNotification()

onMounted(() => {
  void plantStore.get(props.id)
})

function deletePlant() {
  confirm.require({
    message: `Xác nhận xoá cây ${plant.value.name}?`,
    header: 'Xoá cây',
    icon: 'pi pi-info-circle',
    acceptClass: 'p-button-danger',
    accept: () => {
      try {
        isLoading.value = true
        void plantStore.delete(props.id)
        notification.showMessage('Đã xoá cây thuốc thành công')
        router.push({name: 'plants'})
      } finally {
        isLoading.value = false
      }
    }
  })
}

function activePlant() {
  const publish = plant.value.publish
  try {
    isLoading.value = true
    void plantStore.update(props.id, {
      ...plant.value,
      publish: !publish
    })

    if (!publish) {
      notification.showMessage('Đã hiển thị cây thuốc thành công')
    } else {
      notification.showMessage('Đã ẩn cây thuốc thành công')
    }
  } finally {
    isLoading.value = false
  }
}

const __returned__ = { edit, props, tabIndex, isLoading, confirm, plantStore, plant, router, notification, deletePlant, activePlant, PlantForm, ImageViewList }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})